import { BasicUser } from './basicUser.model';

export type PositionNoteType = 'NOTE' | 'ACTION';

/**
 * Represents a note or action item attached to a portfolio position.
 */
export class PositionNote {
  private static readonly DEFAULT_DATE_FORMAT: Intl.DateTimeFormatOptions = {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York'
  };

  id: number;
  positionId: number;
  text: string;
  positionNoteType: PositionNoteType;
  active: boolean;
  created: string;
  updated: string;
  createdBy: BasicUser;
  updatedBy: BasicUser;

  constructor(data: any = {}) {
    this.id = data.id ?? null;
    this.positionId = data.positionId ?? null;
    this.text = data.text || '';
    this.positionNoteType = data.positionNoteType || 'NOTE';
    this.active = data.active ?? true;
    this.created = data.created || null;
    this.updated = data.updated || null;
    this.createdBy = data.createdBy ? new BasicUser(data.createdBy) : null;
    this.updatedBy = data.updatedBy ? new BasicUser(data.updatedBy) : null;
  }

  /** Builds a display label with author name and date, joined by the given separator */
  getAuthorLabel(separator: string = ', ', dateFormat: Intl.DateTimeFormatOptions = PositionNote.DEFAULT_DATE_FORMAT): string {
    if (!this.createdBy) {
      return '';
    }
    const name = this.createdBy.fullName || '';
    const date = this.created
      ? new Date(this.created.endsWith('Z') ? this.created : this.created + 'Z').toLocaleString('en-US', dateFormat)
      : '';
    return name && date ? `${name}${separator}${date}` : name || date;
  }
}
